import { render, staticRenderFns } from "./DetailsSectionOrders.vue?vue&type=template&id=0dfc1d44&"
import script from "./DetailsSectionOrders.vue?vue&type=script&lang=js&"
export * from "./DetailsSectionOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports